export default {
  "command.title": "Ask a side question",
  "command.description": "Get a one-shot answer without adding to the conversation",
  "tab.title": "/btw",
  "question.required": "Add a question after /btw",
  error: "Couldn’t answer that question",
  retry: "Retry",
  copy: "Copy answer",
}
